import React, {useState, useEffect} from 'react'
import {GoogleMap, LoadScript, Marker, InfoWindow, Data} from '@react-google-maps/api'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faStreetView} from '@fortawesome/free-solid-svg-icons'
import './map.css'
import {Button} from 'react-bootstrap'
import { textSpanEnd } from 'typescript'
import Navigation from "../Navigation/navigation"
import { GetUserList, GetUser, UpdateUser } from '../Shared/user.service'
import { IUser } from '../Shared/user.interface'
import firebase from 'firebase/app'
import 'firebase/auth'
import { v4 as uuidv4 } from 'uuid';
import { spawn } from 'child_process'

// const test_player = {id:0, location: {lat: 29.65, lng: -82.3}}
// const test_other_players = [{id:1, location: {lat: 29.7, lng: -82.3}}, {id: 2, location: {lat: 29.6, lng: -82.3}}]
// let test_mons : Array<Mon>;
// test_mons = [];

interface Coords {
  lat: number,
  lng: number
}

interface Player {
  id: number,
  location: Coords
}

export interface Mon {
  id : string
  img : string
  location: Coords,
}

interface MapProps {
  center: Coords,
  player: Player,
  other_players: Player[],
  mons: Mon[]
}

const GameMap = ()=>{
  const [ selected, setSelected ] = useState(null as Mon | null);
  const [ users, setUsers] = useState([] as IUser[] )
  const [ mons, setMons ] = useState([] as Mon[]);
  const [ user, setUser] = useState( null as IUser | null)

  useEffect(() => {
    const getUsers = async() => {
      setUsers(await GetUserList()); 
      const user = firebase.auth().currentUser as IUser | null;

      if(user){
        const userInfo = await GetUser(user.email)
        setUser(userInfo)
        // console.log(await GetUser(user.email))
      }
    }
    getUsers();
  }, [])

  // Set specifc time
  useEffect(() => {
    const interval = setInterval(() => {
      console.log(currentPosition())
      if (currentPosition()) {
        spawnMon(currentPosition() as Coords)
      }
    }, 2000)
    return () => clearInterval(interval)
  }, [])

  // useEffect(() => {
  //   const getMons = () => {
  //     const newMons: Mon[] = []
  //     if (currentPosition()) {
  //       for (let i = 0; i < 8; i++) {
  //         newMons.push(spawnMon(currentPosition() as Coords))
  //       }
  //     }
  //     setMons(newMons)
  //   }
  //
  //   getMons()
  //   const interval = setInterval(() => getMons(), 6000)
  //   return () => {
  //     clearInterval(interval)
  //   }
  // }, [])

  const spawnMon = (reference_coords : Coords) => {
    const species = 20;
    const range = 0.01;
    const newMons: Mon[] = []
    for (let i = 0; i < 12; i++) {
      const newMon: Mon = {
        id: uuidv4(),
        img: 'gator' + Math.ceil(Math.random() * species).toString() + '.png',
        location: {
          lat: reference_coords.lat + Math.random() * range - range / 2,
          lng: reference_coords.lng + Math.random() * range - range / 2
        }
      }
      newMons.push(newMon)
    }
    setMons([...mons, ...newMons])
  }

  const action = () => {
    getLocation()
    if (currentPosition()) {
      spawnMon(currentPosition() as Coords)
    }
  }

  async function getLocation() {
    navigator.geolocation.getCurrentPosition((position)=>{
      if(user && position){
        user.currentLocation = {lat: position.coords.latitude, long: position.coords.longitude}
        UpdateUser(user)
      }

    });
  }

  const onSelect = (mon : Mon) => {
    console.log(mon)
    setSelected(mon);
  }

  const getDistance = (loc1 : Coords, loc2 : Coords) => {
    console.log(Math.pow(loc1.lat - loc2.lat, 2) + Math.pow(loc2.lng - loc2.lng, 2))
    return Math.pow(loc1.lat - loc2.lat, 2) + Math.pow(loc1.lng - loc2.lng, 2)
  }

  const mapStyles = () => {
    return {
      width: "100%",
      height: "100%", 
      borderRadius: "20px",
    }
  }

  const currentPosition = (): Coords | null => {
    console.log(user)
    if (user?.currentLocation) {
      return {lat: user.currentLocation.lat, lng: user.currentLocation.long}
    }
    return null;
  }


  return(
    <div className="game-map-container">
      <div className="GameMapStyles">
        <LoadScript
          id="script-loader"
          googleMapsApiKey='AIzaSyDDzAGhmk2jio6ei6HlRHtKW6MW0lHx6Lc'
        >
          <GoogleMap
            id='example-map'
            mapContainerStyle={mapStyles()}
            zoom={13}
            center={currentPosition() ? currentPosition() : {lat: 29.65, lng: -82.3}}
          >
            { currentPosition() && <Marker
              position={currentPosition()}
              icon={faStreetView}
            /> }
            {

              users?.map((other_player) => {
                if (other_player.currentLocation) {
                  return (
                    <Marker
                      key={other_player.email}
                      position={{ lat: other_player.currentLocation.lat, lng: other_player.currentLocation.long }}
                      options={{
                        icon: {
                          url: 'Avatar' + Math.ceil(Math.random() * 11 + 1).toString() + '.png',
                          scaledSize: { width: 32, height: 32 },
                          anchor: { x: 16, y: 0 }
                        }
                      }}
                    />
                  )
                }
              })
            }
            {
              mons ?
              mons.map((mon)=>{
                return (
                  <Marker
                    key = {mon.id}
                    position={mon.location}
                    onClick={() => onSelect(mon)}
                    options={{
                      icon: {
                        url: mon.img,
                        scaledSize: {width: 32, height: 32},
                        anchor: {x:16, y:0}
                      }
                    }}
                  />
                )

              }) : console.log("mons did not load")
            }
            {
              selected ? (
                <InfoWindow
                  position={selected.location}
                  onCloseClick={() => setSelected(null)}
                >
                  {
                    getDistance(selected.location, currentPosition() as Coords) < 2e-5?
                    <Button className="catch-button">catch me!</Button>:
                    <div>too far</div>
                  }
                </InfoWindow>
              ) : null
              }
          </GoogleMap>
        </LoadScript>
        <Button onClick={action}>Load Gators!</Button>
      </div>
    </div>
      
    )
}

export default GameMap





